import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as layoutActions from "../../../actions/layoutActions";
import { validatieStatussenLoaded } from "../../../actions/validatieStatusActions";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import * as sessionActions from "../../../actions/sessionActions";
import { throwException } from "../../../actions/exceptionActions";
import IdentificatieForm from "./IdentificatieForm";
import redirector from "../../../util/redirector";
import IdentificatiePageHelper from "./IdentificatiePageHelper";
import ScrollToFirstErrorComponent from "../../common/ScrollToFirstErrorComponent";

class IdentificatiePage extends ScrollToFirstErrorComponent {
    constructor(props, context) {
        super(props, context, true);

        this.filesHelper = null;
        this.state = {
            transactieId: '',
            model: {
                id: null,
                identificatieCode: null,
                datumOprichting: null,
                datumStopzetting: null,
                ondernemingsnummer: null,
                rechtsvorm: null,
                statuut: null
            },
            originalModel: {
                id: null,
                identificatieCode: null,
                datumOprichting: null,
                datumStopzetting: null,
                ondernemingsnummer: null,
                rechtsvorm: null,
                statuut: null
            },
            hasUnsavedChanges: false,
            shouldScrollToFirstError: false,
            validationMessageType: '',
            errors: {},
            datumOprichtingHasFocus: true
        };

        this.pageHelper = new IdentificatiePageHelper(this, redirector);
    }

    componentDidMount = () => {
        this.props.setHasUnsavedChanges(false);
        super.componentDidMount();
        this.pageHelper.init();
    };

    handleOnSave = () => this.pageHelper.save();
    handleOnChange = (event) => this.pageHelper.change(event);

    render() {
        const props = this.props;
        const state = this.state;
        const model = state.model;
        const originalModel = state.originalModel;
        const errors = state.errors;
        const disabled = props.disabled;
        const statuten = props.statuten;
        const rechtsvormen = props.rechtsvormen;

        return (
            <IdentificatieForm
                model={model}
                originalModel={originalModel}
                onDropFiles={this.handleOnDropFiles}
                onRemoveFile={this.handleOnRemoveFile}
                onChange={this.handleOnChange}
                onSave={this.handleOnSave}
                errors={errors}
                disabled={disabled}
                validationMessageType={this.state.validationMessageType}
                statuten={statuten}
                rechtsvormen={rechtsvormen}
                datumOprichtingHasFocus={state.datumOprichtingHasFocus}
            />);
    }
}

IdentificatiePage.propTypes = {
    loadLayout: PropTypes.func
};

function mapStateToProps(state, ownProps) {
    return {
        federatieId: state.security.currentOrganisationInfo? state.security.currentOrganisationInfo.id: null,
        statuten: state.referentie.statuten.filter(x => [2, 3].indexOf(x.value) != -1),
        rechtsvormen: state.referentie.rechtsvormen,
        disabled: state.session.readOnly,
        isNew: state.session.isNew
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        validatieStatussenLoaded: bindActionCreators(validatieStatussenLoaded, dispatch),
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        throwException: bindActionCreators(throwException, dispatch),
        setTabSettings: bindActionCreators(layoutActions.setTabSettings, dispatch),
        setActiveTransaction: bindActionCreators(sessionActions.setActiveTransactionId, dispatch),
        setHasUnsavedChanges: bindActionCreators(sessionActions.setHasUnsavedChanges, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(IdentificatiePage);